import type { OnChangeFn, SortingState, VisibilityState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import { useProductTestDocumentColumns } from "@/screens/Products/components/Product/Quality/TestResults/hooks"

interface ProductTestDocumentsTableProps {
  data: SignedUrl[]
  sorting?: SortingState
  canDownload?: boolean
  canDelete?: boolean
  columnVisibility?: VisibilityState
  onSortingChange?: OnChangeFn<SortingState>
  onDelete: (document: SignedUrl) => void
}

export const ProductTestDocumentsTable: FC<ProductTestDocumentsTableProps> = ({
  data,
  sorting,
  canDownload = true,
  canDelete = true,
  columnVisibility,
  onSortingChange,
  onDelete,
}) => {
  const columns = useProductTestDocumentColumns({ canDownload, canDelete, onDelete })

  return (
    <AerosBaseTable
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            sorting,
            columnVisibility,
          },
          enableSortingRemoval: false,
          enableSorting: true,
          getCoreRowModel: getCoreRowModel(),
          onSortingChange,
        },
      }}
      noDataMessage='No documents found'
    />
  )
}
